import { Injectable } from '@angular/core';

import { CustomHttpService } from './custom-http.service';
import { HttpOptionsModel } from '../models';

@Injectable()
export class PokerService {

  constructor(private customHttpService: CustomHttpService) {}

  getWallet() {
    let httpOptions = new HttpOptionsModel('/dzpoker/wallet', null , false, true);
    return this.customHttpService.post(httpOptions);
  }

  deposit(amount){
    let httpOptions = new HttpOptionsModel('/dzpoker/deposit', {amount:amount} , false, true);
    return this.customHttpService.post(httpOptions);
  }

  withdraw(amount){
    let httpOptions = new HttpOptionsModel('/dzpoker/withdraw', {amount:amount} , false, true);
    return this.customHttpService.post(httpOptions);
  }

}



// WEBPACK FOOTER //
// C:/Users/IsaGul/Desktop/beyn-projects/commercial-front-end/src/app/shared/services/poker.service.ts